<template>
  <div>
    <l-map
      ref="map"
      :zoom="zoom"
      :center="center"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      :bounds="markerBounds"
      :zoom-animation="true"
      :fade-animation="true"
      :marker-zoom-animation="true"
      :zoom-animation-threshold="10"
      class="map-wrapper"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-marker
        v-for="(marker, idx) in filteredMarkers"
        :ref="'marker-' + marker.user_id"
        :key="idx"
        :lat-lng="getMarkerLatLng(marker)"
        :icon="getMarkerIcon(marker)"
        @click="centerMarker(marker)"
      >
        <l-popup>
          <div class="header">
            <i
              class="activity-icon"
              :class="getStatusClass(marker.status)"
            />
            <h3 class="name">
              {{ marker.user_name }}
            </h3>
            <!--<i class="atto atto-r-arrow-b right-arrow"></i>-->
          </div>
          <div class="details">
            <div class="content-row">
              <span
                v-if="marker.latitude && marker.enabled_location_tracking && locationTracking === 1"
                class="last-sync"
              >
                {{label.get('map_last_location_update')}}  ·  {{ timeAgo(marker.sync_time) }}
              </span>
              <span
                  v-if="marker.latitude && marker.enabled_location_tracking && locationTracking === 2"
                  class="last-sync"
              >
                {{ getStatusLabel(marker.status) }}
              </span>
            </div>
            <div
              v-if="marker.enabled_location_tracking && !marker.enabled_location_permission"
              class="content-row off"
            >
              <i class="atto atto-no-location-pin" />
              <p class="b location-off">
                {{label.get('location_permission')}}
                <i class="atto atto-alert-triangle" />
              </p>
            </div>
            <div
              v-else
              class="content-row"
            >
              <i
                class="atto atto-location-marker-lt"
                :class="getStatusClass(marker.status)"
              />
              <p class="b">
                {{ marker.address }}
              </p>
            </div>
            <div class="content-row column">
              <span
                v-if="marker.accuracy"
                class="acc"
              >{{ marker.accuracy }}</span>
              <span
                v-if="marker.status_label"
                class="clocked-in"
              >{{ marker.status_label }}</span>
            </div>
          </div>
        </l-popup>
      </l-marker>
    </l-map>
    <div
      v-if="manualMarker"
      class="manual-marker"
    >
      <div class="header">
        <i
          class="activity-icon"
          :class="getStatusClass(manualMarker.status)"
        />
        <h3 class="name">
          {{ manualMarker.user_name }}
        </h3>
        <i
          class="atto atto-close-btn"
          @click="closeManualMarker"
        />
      </div>
      <div class="details">
        <div class="content-row">
          <span
            v-if="manualMarker.enabled_location_tracking"
            class="last-sync"
          >
            {{label.get('location_not_available')}}
          </span>
          <span
            v-if="!manualMarker.enabled_location_tracking"
            class="last-sync"
          >
            {{label.get('location_tracking_for_user_disabled')}}
          </span>
        </div>
        <div class="content-row off">
          <i class="atto atto-no-location-pin" />
          <p class="b ">
            {{ manualMarker.address }}
          </p>
        </div>
        <div class="content-row column">
          <span class="clocked-in">{{ manualMarker.status_label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LocationService from "../shared/LocationService";

    export default {
        name: "MapComponent",
        props: {
            markers: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },
        data() {
            return {
                maxZoom: 18,
                minZoom: 5,
                zoom: 13,
                center: [0, 0],
                bounds: null,
                url: 'https://{s}-tiles.locationiq.com/v2/obk/r/{z}/{x}/{y}.png?key=pk.b79bd6c735e4ccd1a09bace11fdbd698',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                options: {
                    animate: true,
                    pan: {
                        duration: 10
                    }
                },
                manualMarker: null,
                locationTracking: this.$store.state.companySettings.location_tracking
            }
        },
        computed: {
            markerBounds: function () {
                return this.getBounds(this.markers);
            },
            filteredMarkers: function () {
                const markers = this.markers.filter(item => {
                    return item.latitude != null;
                });
                this.getInitialCenter();
                return markers;
            }
        },
        mounted() {
            this.$root.$on('centerMap', this.centerMarker);
            this.$root.$on('closeAllMarkers', this.closeAllMarkers);
        },
        beforeDestroy() {
            this.$root.$off('centerMap');
            this.$root.$off('closeAllMarkers');
        },
        methods: {
            getStatusClass(status) {
                if (status === 0) {
                    return 'clockedIn';
                } else if (status === 1) {
                    return 'clockedOut';
                } else if (status === 4) {
                    return 'onBreak';
                } else {
                    return 'notActive';
                }
            },
            getStatusLabel(status) {
              if (status === 0) {
                return this.label.get('clock_in_location');
              } else if (status === 1) {
                return this.label.get('clock_out_location');
              } else if (status === 4) {
                return this.label.get('break_start_location');
              }
            },
            zoomUpdated(zoom) {
                this.zoom = zoom;
            },
            centerUpdated(center) {
                this.center = center;
            },
            boundsUpdated(bounds) {
                this.bounds = bounds;
            },
            getInitialCenter() {
                const x = localStorage.getItem('location');
                if (x !== undefined && x !== null && this.center[0] ===0 && this.center[1] === 0) {
                    this.center = JSON.parse(x);
                }
                if (this.markers.length === 0) {
                    const _this = this;
                    navigator.geolocation.getCurrentPosition(function (position) {
                        const myLatLng = [position.coords.latitude, position.coords.longitude];
                        localStorage.setItem('location', JSON.stringify(myLatLng));
                        _this.center = myLatLng;
                    });
                }
            },
            getMarkerLatLng(marker) {
                return L.latLng(marker.latitude, marker.longitude);
            },
            getBounds(markers) {
                let _this = this;
                let bounds = new L.LatLngBounds();
                if(markers.length === 0) {
                  const latlngS = L.latLng(0.0, 0.0);
                  const latlngE = L.latLng(0.0, 0.0);
                  bounds = new L.LatLngBounds(latlngS, latlngE);
                }

                markers.forEach(function (marker) {
                    bounds.extend(_this.getMarkerLatLng(marker));
                });
                return bounds;
            },
            timeAgo(syncTime) {
                let diff = this.$moment().diff(this.$moment(syncTime));
                if (diff * 0.001 < 60) {
                    return this.label.get('just_now');
                }
                return this.$moment(syncTime).startOf('minute').fromNow();
            },
            getMarkerIcon(marker) {
                if (marker.status === 0) {
                    return L.divIcon({
                        iconSize: new L.Point(60, 60),
                        html: '<span class="inner-clockin"></span>'
                    });
                } else if (marker.status === 4) {
                    return L.divIcon({
                        iconSize: new L.Point(60, 60),
                        html: '<span class="inner-break"></span>'
                    });
                } else {
                    return L.divIcon({
                        iconSize: new L.Point(60, 60),
                        html: '<span class="inner-clockout"></span>'
                    });
                }
            },
            centerMarker(marker, fromClickEvent = true, showPopUp = true) {
                let _this = this;
                _this.manualMarker = null;
                if (marker.latitude !== null) {
                    this.centerUpdated([marker.latitude, marker.longitude]);
                    if (!fromClickEvent && _this.$refs['marker-' + marker.user_id] !== undefined
                        && _this.$refs['marker-' + marker.user_id].length > 0) {
                        const currentZoom = _this.$refs['map'].mapObject._zoom;
                        const position = _this.$refs['marker-' + marker.user_id][0].mapObject.getLatLng();
                        _this.$refs['map'].mapObject.setView(position, currentZoom < 16 ? 16 : currentZoom);
                        if (showPopUp) {
                            setTimeout(function () {
                                _this.$refs['marker-' + marker.user_id][0].mapObject.openPopup();
                            }, 300);
                        }
                    }
                    if (marker.address === null || marker.address === '') {
                        marker.address = this.label.get('locating');
                        LocationService.getLocationAddress(marker.latitude + ',' + marker.longitude, marker.user_id).then((result) => {
                            marker.address = result.address;
                        }).catch((error) => {
                        });
                    }
                } else {
                    this.markers.forEach((item) => {
                        if (this.$refs['marker-' + item.user_id] !== undefined && this.$refs['marker-' + item.user_id].length > 0) {
                            this.$refs['marker-' + item.user_id][0].mapObject.closePopup();
                        }
                    });

                    if (showPopUp) {
                        _this.manualMarker = marker;

                    }
                }

            },
            closeManualMarker() {
                this.manualMarker = null;
            },
            closeAllMarkers() {
                this.manualMarker = null;
                this.markers.forEach((item) => {
                    if (this.$refs['marker-' + item.user_id] !== undefined && this.$refs['marker-' + item.user_id].length > 0) {
                        this.$refs['marker-' + item.user_id][0].mapObject.closePopup();
                    }
                });
            }
        }
    }
</script>

<style lang="scss">

    .vue2leaflet-map,
    .map-wrapper {
        height: calc(100vh - 60px) !important;
    }

    .leaflet-popup {
        width: 383px;
        margin-bottom: 30px;

        .leaflet-popup-content-wrapper {
            /*min-height: 214px;*/
            box-shadow: 0 -2px 10px 0 rgba(199, 199, 199, 0.5);
            border-radius: 0;
            padding: 0;
        }

        .leaflet-popup-content {
            width: 100% !important;
            display: flex;
            flex-direction: column;
            padding: 0;
            margin: 0;

            > div {
                padding: 16px 16px 24px;
            }

            .header {
                display: flex;
                align-items: center;
                flex-direction: row;
                padding-bottom: 16px;
                height: 24px;
                box-sizing: content-box;

                i.activity-icon {
                    margin-right: 16px;
                }

                h3 {
                    color: $atto-font-color;
                    font: $roboto-medium 1rem/1rem $roboto-font;
                    margin-right: 16px;
                }

                i.right-arrow {
                    font-size: 14px;
                    color: #efefef;
                }

                /*border-bottom: 1px solid #efefef;*/
              border-bottom: none;
            }

            .details {
                padding-top: 0;
                display: flex;
                flex-direction: column;

                .content-row {
                    padding-left: 32px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    position: relative;
                    margin-bottom: 4px;

                    span {
                        font-size: 0.75rem;
                        line-height: 1rem;
                        font-family: 'Roboto', sans-serif;
                        font-weight: 400;
                        color: #999;
                    }

                    i.atto-location-marker-lt {
                        position: absolute;
                        left: 8px;
                        top: 4px;
                        font-size: 16px;

                        &.clockedIn {
                            &:before {
                                color: #06B879
                            }
                        }

                        &.clockedOut {
                            &:before {
                                color: #E05656
                            }
                        }

                        &.onBreak {
                            &:before {
                                color: #FBA345
                            }
                        }

                        &.notActive {
                            &:before {
                                color: #999999
                            }
                        }

                        &.locationOff {
                            &:before {
                                color: #06B879
                            }
                        }
                    }

                    i.atto-no-location-pin {
                        position: absolute;
                        left: 8px;
                        top: 1px;
                        font-size: 16px;
                    }

                    p {
                        margin: 0;
                        font: $roboto-regular 0.875rem/1.25rem $roboto-font;
                        max-width: 260px;
                        display: inline-flex;
                        align-items: center;

                        &.b {
                            font-weight: $roboto-regular;
                        }

                        &.b.location-off {
                            font-weight: 500;
                            color: #E05656;

                            i {
                                margin-left: 10px;
                            }
                        }
                    }

                    &.column {
                        flex-direction: column;
                        margin-bottom: 0;
                        align-items: flex-start;
                    }

                    .clocked-in {
                        color: #262626;
                        margin-top: 16px;
                    }
                }

              &:before{
                display: block;
                content: '';
                width: 20px;
                height: 2px;
                background-color: #EFEFEF;
                margin: 0 28px 20px;

              }
            }
        }

    }

    .leaflet-container.map-wrapper {
        a.leaflet-popup-close-button {
            right: 21px;
            top: 21px;
            font-size: 0;
            margin: 0;
            padding: 0;
            width: 14px;
            height: 14px;
            background-image: url('~@assets/images/close-popup-btn.svg');
            background-repeat: no-repeat;
            background-position: center;
            opacity: 1;
        }

        .leaflet-div-icon {
            background: transparent;
            border: 0;
        }
    }

    .leaflet-popup-tip-container {
        width: 30px;
        height: 30px;
        margin-left: -15px;

        .leaflet-popup-tip {
            width: 20px;
            height: 20px;
            box-shadow: 0 -2px 10px 0 rgba(199, 199, 199, 0.5);
            color: transparent;
        }
    }

    .leaflet-div-icon {
        background: transparent;
        border: 0;
    }

    .inner-neutral {
        background-image: url('~@assets/images/gray-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }

    .inner-clockin {
        background-image: url('~@assets/images/green-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }

    .inner-clockout {
        background-image: url('~@assets/images/red-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }

    .inner-break {
        background-image: url('~@assets/images/orange-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }

    .manual-marker {
        box-shadow: 0 2px 10px 0 rgba(38, 38, 38, 0.2);
        border-radius: 0;
        background-color: #fff;
        position: absolute;
        z-index: 999;
        left: 50%;
        top: 50%;
        margin-left: -191px;
        width: 383px;
        padding: 16px 16px 24px;
        transform: translateY(-50%);

        .header {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding-bottom: 16px;
            height: 24px;
            box-sizing: content-box;

            i.activity-icon {
                margin-right: 16px;
            }

            h3 {
                font: $roboto-regular 1rem/1.5rem $roboto-font;
                color: $atto-font-color;
                margin-right: 20px;
            }

            i.right-arrow {
                font-size: 14px;
                color: #efefef;
            }

            i.atto-close-btn {
                color: #C7C7C7;
                line-height: 21px;
                position: absolute;
                text-align: center;
                cursor: pointer;
                right: 21px;
                top: 21px;
                font-size: 0;
                margin: 0;
                padding: 0;
                width: 14px;
                height: 14px;
                background-image: url(/images/close-popup-btn.svg?6cabdca…);
                background-repeat: no-repeat;
                background-position: center;
                opacity: 1;

                &:hover {
                    color: #262626;
                }
            }

            border-bottom: none;
        }

        .details {
            padding-top: 0;
            display: flex;
            flex-direction: column;

            .content-row {
                padding-left: 32px;
                display: flex;
                flex-direction: row;
                align-items: center;
                position: relative;
                margin-bottom: 4px;

                span {
                    font-size: 0.75rem;
                    line-height: 1rem;
                    font-family: 'Roboto', sans-serif;
                    font-weight: 400;
                    color: #999;
                }

                i.atto-location-marker-lt {
                    position: absolute;
                    left: 8px;
                    top: 4px;
                    font-size: 16px;

                    &.clockedIn {
                        &:before {
                            color: #06B879
                        }
                    }

                    &.clockedOut {
                        &:before {
                            color: #E05656
                        }
                    }

                    &.onBreak {
                        &:before {
                            color: #FBA345
                        }
                    }

                    &.notActive {
                        &:before {
                            color: #999999
                        }
                    }

                    &.locationOff {
                        &:before {
                            color: #06B879
                        }
                    }
                }

                i.atto-no-location-pin {
                    position: absolute;
                    left: 8px;
                    top: 1px;
                    font-size: 16px;
                }

                p {
                    margin: 0;
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                    font-family: 'Roboto', sans-serif;
                    max-width: 260px;
                    display: inline-flex;
                    align-items: center;

                    &.b {
                        font-weight: 500;
                    }

                    &.b.location-off {
                        font-weight: 500;
                        color: #E05656;

                        i {
                            margin-left: 10px;
                        }
                    }
                }

                &.column {
                    flex-direction: column;
                    margin-bottom: 0;
                    align-items: flex-start;
                }

                .clocked-in {
                    color: #262626;
                    margin-top: 16px;
                }
            }
          &:before{
            display: block;
            content: '';
            width: 20px;
            height: 2px;
            background-color: #EFEFEF;
            margin: 0 28px 20px;

          }
        }
    }
</style>
